import axios from "axios";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

import { Grid } from "@material-ui/core";
import { useParams } from "react-router-dom";

import DataTable from "./DataTable";

const DeviceMonthlyUsageHistory = (props) => {
  const { setError, setLoading, loading } = props;
  const { device_uuid } = useParams();
  const [deviceStat, setDeviceStat] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [metaData, setMetaData] = useState({
    page: 1,
    page_size: 10,
    total: 1,
  });

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (newPageSize) => {
    setCurrentPage(1);
    setPageSize(newPageSize);
  };

  useEffect(() => {
    if (device_uuid !== null) {
      setLoading(true);
      axios
        .get(
          `/device/${device_uuid}/stats?page=${currentPage}&page_size=${pageSize}`
        )
        .then(({ data }) => {
          setDeviceStat(data.mfdevicestats);
          setMetaData({
            page: data.page,
            page_size: data.page_size,
            total: data.total,
          });
          setLoading(false);
        })
        .catch((error) => {
          setError(error.response.data.details);
        })
        .finally(() => {
          setLoading(false);
        });
    }
    // eslint-disable-next-line
  }, [pageSize, currentPage]);

  const columns = [
    {
      field: "mifidvcdate",
      headerName: "Date",
      flex: 1,
    },
    {
      field: "totaldataused",
      headerName: "Used Data [MB]",
      flex: 1,
    },
  ];

  return (
    <>
      <Grid container direction="column" spacing={3}>
        <Grid item>
          {console.log(deviceStat)}
          <DataTable
            columns={columns}
            data={deviceStat}
            loading={loading}
            metaData={metaData}
            getRowId={(row) => row.mifidvcdate}
            handlePageChange={handlePageChange}
            handlePageSizeChange={handlePageSizeChange}
          />
        </Grid>
      </Grid>
    </>
  );
};

DeviceMonthlyUsageHistory.propTypes = {
  setError: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default DeviceMonthlyUsageHistory;
